import React, { useContext, useState, useEffect } from "react";
import { Card, Button, Input, Form, List,message} from "antd";
import { UserContext } from "../UserContext";

const QuizEditor = ({ courseId, moduleId, quizData }) => {
	const [messageApi, contextHolder] = message.useMessage();
	const [editingLevel, setEditingLevel] = useState(null);
	const [updatedQuiz, setUpdatedQuiz] = useState();
	const { instructorapiuri, token } = useContext(UserContext);

	
	useEffect(() => {
		setUpdatedQuiz(quizData);
	}, [quizData]);


	const handleEdit = (level) => {
		setEditingLevel(level);
		console.log(level);
	};

	const handleSave = () => {
		if (editingLevel === "easy")
			saveUpdatedQuizToApi(courseId, moduleId, "e", updatedQuiz.easy);
		else if (editingLevel === "medium")
			saveUpdatedQuizToApi(courseId, moduleId, "m", updatedQuiz.medium);
		else if (editingLevel === "hard")
			saveUpdatedQuizToApi(courseId, moduleId, "h", updatedQuiz.hard);
		setEditingLevel(null);
	};
	
	const generateQuiz = async () =>{
		const response = await fetch(
			`${instructorapiuri}/inst/${courseId}/${moduleId}/quiz/g`,
			{
				method:"GET",
				headers:{
					"Authorization":"BEARER: "+ token
				}
			}
		);
		const data = await response.json();
		console.log(data);
		setUpdatedQuiz(data);
		window.location.reload();
	} 

	const saveUpdatedQuizToApi = async (
		courseId,
		moduleId,
		level,
		updatedQuiz
	) => {
		try {
			const response = await fetch(
				`${instructorapiuri}/inst/${courseId}/${moduleId}/quiz/${level}`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + token,
					},
					body: JSON.stringify({ content: updatedQuiz }),
				}
			);

			if (!response.ok) {
				throw new Error("Network error");
			}

			const data = await response.json();
			messageApi.open({
				type: "success",
				content: `Quiz content modified Successfully...!`,
			});
		} catch (error) {
			console.error("Error updating quiz:", error.message);
		}
	};

	const handleInputChange = (level, index, field, value) => {
		setUpdatedQuiz((prevQuiz) => {
			const updatedQuestions = { ...prevQuiz };
			updatedQuestions[level][index][field] = value;
			return updatedQuestions;
		});
	};

	const renderQuestionItem = (level, item, index) => (
		<List.Item>
			<Form layout="vertical">
				<Form.Item label={`Question ${index + 1}`}>
					<Input
						value={item.question}
						onChange={(e) =>
							handleInputChange(level, index, "question", e.target.value)
						}
						disabled={editingLevel !== level}
					/>
				</Form.Item>
				<Form.Item label="Options">
					{item.options.map((option, optionIndex) => (
						<Input
							key={optionIndex}
							value={option}
							onChange={(e) =>
								handleInputChange(
									level,
									index,
									"options",
									updateOption(item.options, optionIndex, e.target.value)
								)
							}
							disabled={editingLevel !== level}
							style={{ marginBottom: "8px" }}
						/>
					))}
				</Form.Item>
				<Form.Item label="Correct Option">
					<Input
						value={item.correctOption.toString()}
						onChange={(e) =>
							handleInputChange(
								level,
								index,
								"correctOption",
								parseInt(e.target.value, 10)
							)
						}
						disabled={editingLevel !== level}
					/>
				</Form.Item>
			</Form>
		</List.Item>
	);

	const updateOption = (options, index, value) => {
		const updatedOptions = [...options];
		updatedOptions[index] = value;
		return updatedOptions;
	};

	if (
		quizData?.easy?.length + quizData?.medium?.length + quizData?.hard?.length !==
		20
	) {
		return <><h1>Error: Not enough questions in the pool!</h1><Button onClick={generateQuiz}>Generate Quiz</Button></>;
	}
	else return (
		<>

			{["easy", "medium", "hard"].map((level) => (
				<Card
					key={level}
					title={`${level.charAt(0).toUpperCase()}${level.slice(1)} Level Quiz`}
					style={{ width: "600px", margin: "20px" }}>
					{editingLevel === level ? (
						<List
							dataSource={updatedQuiz[level]}
							renderItem={(item, index) =>
								renderQuestionItem(level, item, index)
							}
							bordered
							size="small"
							keyExtractor={(item, index) => index.toString()}
						/>
					) : (
						<List
							dataSource={quizData[level]}
							renderItem={(item, index) => (
								<List.Item key={index}>{item.question}</List.Item>
							)}
							bordered
							size="small"
							keyExtractor={(item, index) => index.toString()}
						/>
					)}
					{editingLevel === level ? (
						<Button
							type="primary"
							onClick={handleSave}
							style={{ marginTop: "10px" }}>
							Save
						</Button>
					) : (
						<Button
							type="primary"
							onClick={() => handleEdit(level)}
							style={{ marginTop: "10px" }}>
							Edit
						</Button>
					)}
				</Card>
			))}
		</>
	);
};

export default QuizEditor;
